/** @format */

// The `uiStateStore` AngularJS factory is now registered via UiStateStoreService's @DowngradedService
// mapping in app/common/utils/ui-state-store.service.ts. This file persists only because
// student-import.js side-effect-imports it and courseUnitInfoModal.module.js imports the module-name
// constant below; it folds away with Tier F.
export const uiStateStoreModule = 'student.common.utils.uiStateStore';